var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRequiredBlue = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z",
  fill: "#100226"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.98 11V4.06H7.74V11H5.98ZM6.86 3.24C6.54 3.24 6.27 3.14 6.05 2.93C5.84 2.72 5.73 2.45 5.73 2.12C5.73 1.79 5.84 1.51 6.05 1.31C6.27 1.1 6.54 1 6.86 1C7.18 1 7.46 1.1 7.67 1.31C7.88 1.52 7.99 1.79 7.99 2.12C7.99 2.45 7.88 2.73 7.67 2.93C7.46 3.14 7.18 3.24 6.86 3.24Z",
  fill: "#FFFDFD"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 13,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRequiredBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/required-blue.95de62140851a6804446ca5b9d9b90f4.svg";